
import React  from "react";
import './style.css';
import TopNavButton from './TopNavButton'
import TopNavSlotholder from './TopNavSlotholder'


function App(){
    return(
        <>
            <div >
                <TopNavButton />
            </div>
            <div >
                <TopNavSlotholder />
            </div>
        </>
        
    
    );
}

export default App;